import { useCallback } from 'react';
import { StyleSheet } from 'react-native';

import { AnalyticsEvent } from '../../../constants/AnalyticsEvent';
import { coral, neutralGrey, white } from '../../../constants/color';
import useActions from '../../../hooks/useActions';
import { logAnalyticsEvent } from '../../../redux/actions/analyticsLog';
import SearchBar from '../../SearchBar';
import { SEARCH_BAR_MARGIN_BOTTOM, SEARCH_BAR_MARGIN_TOP } from './constants';

const searchBarColors = {
  textColorRange: [neutralGrey],
  backgroundColorRange: [white],
  iconFillColorRange: [coral],
};

const HeaderSearchBar = () => {
  const logEvent: typeof logAnalyticsEvent = useActions(logAnalyticsEvent);

  const logSearchOpen = useCallback(
    (placeholderText: string) => {
      logEvent({
        logEvent: AnalyticsEvent.SearchOpen,
        data: {
          placeholder: placeholderText,
          location: 'header',
        },
      });
    },
    [logEvent]
  );

  return (
    <SearchBar
      logSearchOpen={logSearchOpen}
      {...searchBarColors}
      borderStyle={styles.searchBarBorderStyle}
    />
  );
};

export default HeaderSearchBar;

const styles = StyleSheet.create({
  searchBarBorderStyle: {
    marginLeft: 16,
    marginRight: 14,
    marginTop: SEARCH_BAR_MARGIN_TOP,
    marginBottom: SEARCH_BAR_MARGIN_BOTTOM,
  },
});
